var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "theme-previewer-lib": "static-1.52988"
    },
    "depPathPrefixes": {
      "theme-previewer-lib": "/theme-previewer-lib/static-1.52988"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.38055",
    "project": "theme-previewer-lib",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};